module.exports = __webpack_public_path__ + "static/media/DASH_H.35fe05c8.mov";